import PropTypes from "prop-types";
import { useState } from "react";

// @mui material components
import { Card, Fade, Grid, Icon, InputLabel, Modal, Select, MenuItem } from "@mui/material";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftAlert from "components/SoftAlert";
import { MENSAJE_LEGAJO_BLOQUEADO } from "utils/empresaEstado";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "50%", xxl: "40%" },
  overflowY: "auto",
  p: 3,
};

export default function ModalActividades({ open, handleClose, selectedEmpresa, idUser }) {
  const [actividad, setActividad] = useState("");

  const handlePick = () => {
    if (selectedEmpresa?.estado === "Irregular") return;
    let actividadSeleccionada = actividad?.replace(/ /g, "-").replace(/\//g, "_");
    const idResponsable = idUser || selectedEmpresa?.responsableTecnico?.id;
    if (!selectedEmpresa?.id || !idResponsable || !actividadSeleccionada) return;

    window.location.href = `/declaracion/${selectedEmpresa?.id}/${idResponsable}/${actividadSeleccionada}/nuevo`;
  };

  const cerrarModal = () => {
    handleClose();
    setActividad("");
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={cerrarModal}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center">
              <SoftTypography variant="h6">Seleccionar Actividad</SoftTypography>
              <Icon fontSize="medium" onClick={cerrarModal} sx={{ cursor: "pointer" }}>
                close
              </Icon>
            </SoftBox>
            <SoftBox py={3}>
              {selectedEmpresa?.estado === "Irregular" && (
                <SoftAlert color="error">
                  <SoftTypography variant="caption" color="white">{MENSAJE_LEGAJO_BLOQUEADO}</SoftTypography>
                </SoftAlert>
              )}
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <InputLabel htmlFor="actividad">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Actividades de la empresa seleccionada
                      <SoftTypography variant="caption" fontWeight="bold" color="primary">
                        &nbsp;*
                      </SoftTypography>
                    </SoftTypography>
                  </InputLabel>
                  <Select
                    id="actividad"
                    value={actividad}
                    onChange={(e) => setActividad(e.target.value)}
                    fullWidth
                  >
                    {selectedEmpresa?.actividad?.map((actividad) => (
                      <MenuItem key={actividad} value={actividad}>
                        {actividad}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>
            </SoftBox>
            <SoftBox display="flex" justifyContent="flex-end" alignItems="center">
              <SoftButton color="primary" onClick={cerrarModal} sx={{ marginRight: 1 }}>
                <Icon sx={{ fontWeight: "light" }}>cancel</Icon>
                &nbsp;Cancelar
              </SoftButton>
              <SoftButton
                color="gobSecondary"
                onClick={handlePick}
                disabled={selectedEmpresa?.estado === "Irregular" || !actividad || !(idUser || selectedEmpresa?.responsableTecnico?.id)}
              >
                <Icon sx={{ fontWeight: "light" }}>receipt</Icon>
                &nbsp;Seleccionar
              </SoftButton>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalActividades.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  selectedEmpresa: PropTypes.object,
  idUser: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
